import noop from 'lodash/noop';

import { persistReducer } from 'Lib/persist';
import type { PersistConfig } from 'Lib/persist/types';

class ReducerRegistry {
  registry: {
    [x: string]: any;
  } = {};
  subscriber: ((registry: any) => void) | null = null;

  getRegistry() {
    return this.registry;
  }

  emitChange() {
    if (this.subscriber) {
      this.subscriber(this.registry);
    }
  }

  register(name: string, dynamicReducer: any, persistConfig?: PersistConfig) {
    if (!this.registry[name]) {
      this.registry[name] = !persistConfig
        ? dynamicReducer
        : persistReducer(
            {
              key: name,
              ...persistConfig,
            },
            dynamicReducer
          );
      this.emitChange();
    }
  }

  subscribe(callback: VoidFunction = noop): {} {
    this.subscriber = callback;

    return {
      unsubscribe: () => {
        this.subscriber = null;
      },
    };
  }
}

export default new ReducerRegistry();
